
define('text!views/linkedcards/linkedcard.html',[],function () { return '<a class="js-editLinkedCard">\r\n\t<%- data.cardLogo %>\r\n\t<p class="linked-card-name">\r\n\t\t<%- data.NickName %>\r\n\t\t<% if(data.NickName != data.Identifier){  %>\r\n\t\t\t- <%- data.Identifier %>\r\n\t\t<% } %>\r\n\t</p>\r\n</a>';});

